import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-result-placeholder',
  templateUrl: './empty-result-placeholder.component.html',
  styleUrls: ['./empty-result-placeholder.component.scss']
})
export class EmptyResultPlaceholderComponent {
  @Input() emptyResultsTitle = 'No items found.';
  @Input() emptyResultsText: string;
  @Input() borderless? = false;
}
